import { QueryState } from "src/app/core/models/query.model";
import { createTokenQueryServiceInstance } from "src/app/core/services/query-sentrynel.service";
import { SignalStoreConfig } from "src/app/shared/functions/store.functions";
import { FILES_ENDPOINT } from "./file.config";

export const SUBMISSION_TYPE_ENDPOINT = 'files';
export const SUBMISSION_TYPE_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(SUBMISSION_TYPE_ENDPOINT);


export const submissionTypeStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}
